<template>
  <div
    v-if="hasSlotDefault"
    class="sidebar-form">
    <slot />
  </div>
</template>
<script>
export default {
  computed: {
    hasSlotDefault() {
      return !!this.$slots.default;
    }
  }
};
</script>
